import { Injectable, effect, signal } from "@angular/core";
import { THEME_COLORS } from "../shared/models/theme-colors.model";
import { THEME_SCHEMES } from "../shared/models/theme-scheme.model";
@Injectable({ providedIn: "root" })
export class ThemeService {
    private readonly document = document;

    readonly colors = THEME_COLORS;
    readonly schemes = THEME_SCHEMES;

    private readonly selectedColor = signal(this.colors[0]);
    private readonly selectedScheme = signal(this.schemes[2]);

    setColor(name: string) {
        const color = this.colors.find((c) => c.name === name);
        if (color) this.selectedColor.set(color);
    }

    setScheme(name: string) {
        const scheme = this.schemes.find((s) => s.name === name);
        if (scheme) this.selectedScheme.set(scheme);
    }

    constructor() {
        effect(() => {
            const root = this.document.documentElement;

            this.colors.forEach((c) => root.classList.remove(c.themeClass));
            this.schemes.forEach((s) => root.classList.remove(s.value));

            root.classList.add(this.selectedColor().themeClass);
            root.classList.add(this.selectedScheme().value);
        });
    }
}
